export default "__VITE_ASSET__b2718b0a__"